import { useSelector } from 'react-redux';

/**
 * Admin capability helpers.
 *
 * The capabilities live on the user as `adminCapabilities`, and `superadmin`
 * implies every other capability.
 */
export const hasCapability = (adminCapabilities = [], capability) =>
  adminCapabilities.includes('superadmin') || adminCapabilities.includes(capability);

/**
 * Capability check for the logged in admin. Returns false for every other role,
 * so screens do not have to repeat the `role === 'admin'` part.
 */
export const useAdminCapability = (capability) => {
  const user = useSelector((state) => state?.auth?.user);
  const { role, adminCapabilities = [] } = user || {};

  return role === 'admin' && hasCapability(adminCapabilities, capability);
};
